import classNames          from 'classnames';
import * as React          from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation }  from 'react-i18next';
import {
  FacebookShareButton,
  FacebookIcon,
  VKShareButton,
  TelegramShareButton,
  TelegramIcon,
  ViberShareButton,
  ViberIcon,
}                          from 'react-share';

import useIsMounted from '../../hooks/useIsMounted';
import ShareIcon    from '../icons/ShareIcon';
import Popover      from '../Popover';

export const ShareBlock = function(props) {
  const { t } = useTranslation();

  const { link } = props;

  const [copied, setCopied] = React.useState(false);

  const isMounted = useIsMounted();

  // `link` may be relative (an offer's urlKey); no link means the current page. Resolved only
  // after mount: window is unavailable on the server, and resolving it during hydration would
  // make the first client render differ from the server HTML.
  const url = React.useMemo(() => {
    if (!isMounted) {
      return '';
    }

    return link ? new URL(link, window.location.origin).href : window.location.href;
  }, [isMounted, link]);

  const onCopy = React.useCallback(() => {
    setCopied((prev) => !prev);
  }, []);

  return (
    <div
      className={'share'}
      onClick={(event) => event.stopPropagation()}
    >
      <Popover
        className={'large'}
        content={(
          <>
            <div className={'share-social'}>
              <FacebookShareButton
                className={'share-facebook'}
                resetButtonStyle={false}
                url={url}
              >
                <FacebookIcon
                  borderRadius={2}
                  size={36}
                />
              </FacebookShareButton>
              <VKShareButton
                className={'share-vk'}
                resetButtonStyle={false}
                url={url}
              >
                <span className={'ic-vk-mono'} />
              </VKShareButton>
              <ViberShareButton
                className={'share-viber'}
                resetButtonStyle={false}
                url={url}
              >
                <ViberIcon
                  borderRadius={2}
                  size={36}
                />
              </ViberShareButton>
              <TelegramShareButton
                className={'share-telegram'}
                resetButtonStyle={false}
                url={url}
              >
                <TelegramIcon
                  borderRadius={2}
                  size={36}
                />
              </TelegramShareButton>
            </div>
            <CopyToClipboard
              onCopy={onCopy}
              text={url}
            >
              <span className={classNames('btn primary copy', { disabled: copied })}>
                <span className={copied ? 'ic-check' : 'ic-copy'} />
                {copied ? t('btn_copy_url_done') : t('btn_copy_url')}
              </span>
            </CopyToClipboard>
          </>
        )}
        overlay={true}
        placement={'bottom'}
        trigger={'click'}
      >
        <span className={'btn text'}><ShareIcon /></span>
      </Popover>
    </div>
  );
};
